export default __webpack_public_path__ + "static/media/office_web-md@1x.91932ddf.jpg";